const checkedValidator = (value: any) => {
  if (value !== true) {
    return "error.checked";
  }
  return "";
};
export default checkedValidator;
